import { render, staticRenderFns } from "./FillForm2.vue?vue&type=template&id=1b97b4e3&scoped=true"
import script from "./FillForm2.vue?vue&type=script&lang=ts"
export * from "./FillForm2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b97b4e3",
  null
  
)

export default component.exports